import { ModelSagres } from "../../model-sagres";
import { AtracaoArtistica } from "./atracao-artistica";

export class Programacao extends ModelSagres {
  IdProgramacao: number;
  IdUnidGestora: number;
  IdTipoEvento: number;
  NmEvento: string;
  DtCadastro: Date;
  NmUsuarioCadastro: string;
  DtUltimaAlteracao: Date;
  NmUsuarioUltimaAlteracao: string;
  AtracaoArtistica?: AtracaoArtistica[]


  tratarDadosDaAPI(): void {
    if (this.DtCadastro) {
      this.DtCadastro = new Date(this.DtCadastro);
    }

    if (this.DtUltimaAlteracao) {
      this.DtUltimaAlteracao = new Date(this.DtUltimaAlteracao);
    }
  }
}